import { api } from "@/api";
import { SportWithTranslations } from "@/types/ApiResponses/Sport";

export const getSportWithTranslations = async (
  id: number
): Promise<SportWithTranslations> => {
  const res = await api.client.get(`/sports-new/with-translations/${id}`);
  return res.data;
};
